import { useEffect, useMemo, useState } from 'react';
export default function useInputValue(props, defaultInitialValue) {
    const initialValue = useMemo(() => props.value ?? props.initialValue, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const [value, setValue] = useState(initialValue ?? defaultInitialValue);
    // Controlled value update
    useEffect(() => {
        if (props.value !== undefined) {
            setValue(props.value);
        }
    }, [props.value, setValue]);
    return [value, setValue, initialValue];
}
//# sourceMappingURL=UseInputValue.js.map